import React from "react";
import { FiEdit, FiLayers } from "react-icons/fi";

export default function BulkEditButton({ onClick, title = "Bulk Edit", isActive = false }) {
    return (
        <button
            onClick={onClick}
            aria-label={title}
            className="w-10 h-10 flex items-center justify-center rounded-full transition-colors duration-150 focus:outline-none"
            style={{ background: 'var(--color-muted-bg)', color: 'var(--color-text)' }}
            title={title}
        >
            {isActive ? <FiLayers className="w-5 h-5" /> : <FiEdit className="w-5 h-5" />}
        </button>
    );
}
